
import { CronExpressionParser } from 'cron-parser';
import { DateTime } from 'luxon';
export const timezoneOptions = [
  { label: "(GMT-12:00) International Date Line West", value: "Etc/GMT+12" },
  { label: "(GMT-11:00) Midway Island", value: "Pacific/Midway" },
  { label: "(GMT-11:00) American Samoa", value: "Pacific/Pago_Pago" },
  { label: "(GMT-10:00) Hawaii", value: "Pacific/Honolulu" },
  { label: "(GMT-09:00) Alaska", value: "America/Anchorage" },
  { label: "(GMT-08:00) Pacific Time", value: "America/Los_Angeles" },
  { label: "(GMT-08:00) Tijuana", value: "America/Tijuana" },
  { label: "(GMT-07:00) Mountain Time", value: "America/Denver" },
  { label: "(GMT-07:00) Arizona", value: "America/Phoenix" },
  { label: "(GMT-07:00) Chihuahua", value: "America/Chihuahua" },
  { label: "(GMT-07:00) Mazatlan", value: "America/Mazatlan" },
  { label: "(GMT-06:00) Central Time", value: "America/Chicago" },
  { label: "(GMT-06:00) Saskatchewan", value: "Canada/Saskatchewan" },
  { label: "(GMT-06:00) Mexico City", value: "America/Mexico_City" },
  { label: "(GMT-06:00) Monterrey", value: "America/Monterrey" },
  { label: "(GMT-06:00) Central America", value: "America/Guatemala" },
  { label: "(GMT-05:00) Eastern Time", value: "America/New_York" },
  { label: "(GMT-05:00) Indiana (East)", value: "America/Indiana/Indianapolis" },
  { label: "(GMT-05:00) Bogota", value: "America/Bogota" },
  { label: "(GMT-05:00) Lima", value: "America/Lima" },
  { label: "(GMT-04:00) Atlantic Time", value: "Canada/Atlantic" },
  { label: "(GMT-04:00) Caracas", value: "America/Caracas" },
  { label: "(GMT-04:00) La Paz", value: "America/La_Paz" },
  { label: "(GMT-04:00) Santiago", value: "America/Santiago" },
  { label: "(GMT-03:30) Newfoundland", value: "America/St_Johns" },
  { label: "(GMT-03:00) Brasilia", value: "America/Sao_Paulo" },
  { label: "(GMT-03:00) Buenos Aires", value: "America/Argentina/Buenos_Aires" },
  { label: "(GMT-03:00) Georgetown", value: "America/Guyana" },
  { label: "(GMT-03:00) Greenland", value: "America/Godthab" },
  { label: "(GMT-02:00) Mid-Atlantic", value: "America/Noronha" },
  { label: "(GMT-01:00) Azores", value: "Atlantic/Azores" },
  { label: "(GMT-01:00) Cape Verde", value: "Atlantic/Cape_Verde" },
  { label: "(GMT+00:00) London", value: "Europe/London" },
  { label: "(GMT+00:00) Dublin", value: "Europe/Dublin" },
  { label: "(GMT+00:00) Lisbon", value: "Europe/Lisbon" },
  { label: "(GMT+00:00) Casablanca", value: "Africa/Casablanca" },
  { label: "(GMT+00:00) Monrovia", value: "Africa/Monrovia" },
  { label: "(GMT+01:00) Berlin", value: "Europe/Berlin" },
  { label: "(GMT+01:00) Paris", value: "Europe/Paris" },
  { label: "(GMT+01:00) Madrid", value: "Europe/Madrid" },
  { label: "(GMT+01:00) Rome", value: "Europe/Rome" },
  { label: "(GMT+01:00) Vienna", value: "Europe/Vienna" },
  { label: "(GMT+01:00) Warsaw", value: "Europe/Warsaw" },
  { label: "(GMT+01:00) West Central Africa", value: "Africa/Lagos" },
  { label: "(GMT+02:00) Athens", value: "Europe/Athens" },
  { label: "(GMT+02:00) Bucharest", value: "Europe/Bucharest" },
  { label: "(GMT+02:00) Cairo", value: "Africa/Cairo" },
  { label: "(GMT+02:00) Helsinki", value: "Europe/Helsinki" },
  { label: "(GMT+02:00) Jerusalem", value: "Asia/Jerusalem" },
  { label: "(GMT+02:00) Pretoria", value: "Africa/Johannesburg" },
  { label: "(GMT+03:00) Moscow", value: "Europe/Moscow" },
  { label: "(GMT+03:00) Nairobi", value: "Africa/Nairobi" },
  { label: "(GMT+03:00) Baghdad", value: "Asia/Baghdad" },
  { label: "(GMT+03:00) Riyadh", value: "Asia/Riyadh" },
  { label: "(GMT+03:30) Tehran", value: "Asia/Tehran" },
  { label: "(GMT+04:00) Abu Dhabi", value: "Asia/Dubai" },
  { label: "(GMT+04:00) Baku", value: "Asia/Baku" },
  { label: "(GMT+04:00) Tbilisi", value: "Asia/Tbilisi" },
  { label: "(GMT+04:00) Yerevan", value: "Asia/Yerevan" },
  { label: "(GMT+04:30) Kabul", value: "Asia/Kabul" },
  { label: "(GMT+05:00) Islamabad", value: "Asia/Karachi" },
  { label: "(GMT+05:00) Tashkent", value: "Asia/Tashkent" },
  { label: "(GMT+05:30) India", value: "Asia/Kolkata" },
  { label: "(GMT+05:45) Kathmandu", value: "Asia/Kathmandu" },
  { label: "(GMT+06:00) Almaty", value: "Asia/Almaty" },
  { label: "(GMT+06:00) Dhaka", value: "Asia/Dhaka" },
  { label: "(GMT+06:30) Yangon", value: "Asia/Yangon" },
  { label: "(GMT+07:00) Bangkok", value: "Asia/Bangkok" },
  { label: "(GMT+07:00) Jakarta", value: "Asia/Jakarta" },
  { label: "(GMT+07:00) Krasnoyarsk", value: "Asia/Krasnoyarsk" },
  { label: "(GMT+08:00) Beijing", value: "Asia/Shanghai" },
  { label: "(GMT+08:00) Hong Kong", value: "Asia/Hong_Kong" },
  { label: "(GMT+08:00) Singapore", value: "Asia/Singapore" },
  { label: "(GMT+08:00) Taipei", value: "Asia/Taipei" },
  { label: "(GMT+08:00) Perth", value: "Australia/Perth" },
  { label: "(GMT+08:00) Irkutsk", value: "Asia/Irkutsk" },
  { label: "(GMT+08:00) Ulaanbaatar", value: "Asia/Ulaanbaatar" },
  { label: "(GMT+09:00) Seoul", value: "Asia/Seoul" },
  { label: "(GMT+09:00) Tokyo", value: "Asia/Tokyo" },
  { label: "(GMT+09:00) Yakutsk", value: "Asia/Yakutsk" },
  { label: "(GMT+09:30) Darwin", value: "Australia/Darwin" },
  { label: "(GMT+09:30) Adelaide", value: "Australia/Adelaide" },
  { label: "(GMT+10:00) Brisbane", value: "Australia/Brisbane" },
  { label: "(GMT+10:00) Sydney", value: "Australia/Sydney" },
  { label: "(GMT+10:00) Guam", value: "Pacific/Guam" },
  { label: "(GMT+10:00) Port Moresby", value: "Pacific/Port_Moresby" },
  { label: "(GMT+10:00) Vladivostok", value: "Asia/Vladivostok" },
  { label: "(GMT+11:00) Magadan", value: "Asia/Magadan" },
  { label: "(GMT+11:00) Solomon Islands", value: "Pacific/Guadalcanal" },
  { label: "(GMT+11:00) New Caledonia", value: "Pacific/Noumea" },
  { label: "(GMT+12:00) Auckland", value: "Pacific/Auckland" },
  { label: "(GMT+12:00) Fiji", value: "Pacific/Fiji" },
  { label: "(GMT+12:00) Kamchatka", value: "Asia/Kamchatka" },
  { label: "(GMT+13:00) Nuku'alofa", value: "Pacific/Tongatapu" },
  { label: "(GMT+13:00) Samoa", value: "Pacific/Apia" },
];


export function getNextRun(cronExpression, timeZone) {
  const options = {
    tz: timeZone,
  };
  console.log("formattedNextRun", timeZone);
  try {
    const interval = CronExpressionParser.parse(cronExpression, options);
    const nextRun = interval.next().toISOString();
    const formattedNextRun = DateTime.fromJSDate(nextRun, { zone: timeZone })
      .setZone(timeZone)
      .toFormat('yyyy-MM-dd HH:mm zzz');
      console.log("formattedNextRun luxon",DateTime.now().setZone(timeZone).toISO());
      console.log("formattedNextRun",nextRun);
    return formattedNextRun;
  } catch (err) {
    console.log('Invalid cron:', err.message);
    return null;
  }
}
